import { useCheckVersion } from '../Hooks/useCheckVersion';

export default function VersionBanner() {
  const updateAvailable = useCheckVersion();

  if (!updateAvailable) return null;

  return (
    <div
      className="alert alert-info alert-dismissible fade show fixed-bottom mx-auto w-50 text-center shadow"
      role="alert"
    >
      <span>New version available</span>
      <button
        type="button"
        className="btn btn-sm btn-primary ms-3"
        onClick={() => window.location.reload()}
      >
        Refresh
      </button>
    </div>
  );
}
